import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { useAppSelector } from "@/redux/store.ts";

export default function useProductDownloads() {
    const currentProduct = useCurrentProduct();

    const allowedOptions = useAppSelector((state) => state.downloads.allowedOptions);

    return (
        currentProduct?.properties.documents.value?.filter((document) => allowedOptions.includes(document.subType)) ??
        []
    );
}
